import { Link } from 'react-router-dom'
import MobileMenu from '../MobileMenu/MobileMenu'
import { connect } from "react-redux";
import { removeFromCart } from "../../store/actions/action";



const Header = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
      <header id="header">
        <div className={"" + props.hclass}>
          <nav className="navigation navbar navbar-expand-lg navbar-light">
            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                  <MobileMenu />
                </div>
                <div className="col-lg-2 col-md-6 col-6">
                  <div className="navbar-header">
                    <Link
                      onClick={ClickHandler}
                      className="navbar-brand"
                      to="/"
                    >
                      <img src={props.Logo} alt="logo" />
                    </Link>
                  </div>
                </div>
                <div className="col-lg-7 col-md-1 col-1">
                  <div
                    id="navbar"
                    className="collapse navbar-collapse navigation-holder"
                  >
                    <button className="menu-close">
                      <i className="ti-close"></i>
                    </button>
                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                      <li>
                        <Link onClick={ClickHandler} to="/">
                          Inicio
                        </Link>
                      </li>
                      <li>
                        <Link onClick={ClickHandler} to="/about">
                          Clinica
                        </Link>
                      </li>
                      <li>
                        <Link onClick={ClickHandler} to="/portfolio">
                          Portafolio
                        </Link>
                      </li>
                      <li>
                        <Link onClick={ClickHandler} to="/gallery">
                          Galería de fotos
                        </Link>
                      </li>
                      <li>
                        <Link onClick={ClickHandler} to="/contact">
                          Contacto
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </header>
    );
}
const mapStateToProps = (state) => {
    return {
        carts: state.cartList.cart,
    };
};


export default connect(mapStateToProps, { removeFromCart })(Header);